import { OrmModel, AttrField, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.ORDER)
export default class Order extends BaseModel {
  @StringField()
  public id: string

  @AttrField([])
  public order: string[]
}
